module.exports = __webpack_public_path__ + "static/media/furnestry.20ddd687.png";